/* unplugin-vue-components disabled */import { render } from "./QuizBlanksQuestion.vue?vue&type=template&id=11536ac5&scoped=true&ts=true"
import script from "./QuizBlanksQuestion.vue?vue&type=script&lang=ts"
export * from "./QuizBlanksQuestion.vue?vue&type=script&lang=ts"

import "./QuizBlanksQuestion.vue?vue&type=style&index=0&id=11536ac5&scoped=true&lang=scss"
import "./QuizBlanksQuestion.vue?vue&type=style&index=1&id=11536ac5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11536ac5"]])

export default __exports__